import React, { useState, useMemo } from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import { ButtonText } from '@morressier/alembic';
import { useSubmissionFields } from 'src/hooks/useSubmissionFields';
import { FormFieldAuthors } from '@publishing-engine/domain/types/article';

const MAX_VISIBLE = 2;

const AuthorsTitle: React.FC = () => {
  const { getFieldState } = useSubmissionFields('submission');
  const Authors = getFieldState<FormFieldAuthors>('Authors');

  const [showAll, setShowAll] = useState(false);
  const authors = useMemo(
    () => (Array.isArray(Authors?.value) ? Authors.value : []),
    [Authors]
  );

  const visibleAuthors = useMemo(
    () => (showAll ? authors : authors.slice(0, MAX_VISIBLE)),
    [authors, showAll]
  );

  const remainingCount = authors.length - MAX_VISIBLE;
  const shouldShowToggle = authors.length > MAX_VISIBLE;

  const authorNames = useMemo(
    () =>
      visibleAuthors
        .map(({ firstName, lastName }) => `${firstName} ${lastName}`)
        .join(', '),
    [visibleAuthors]
  );

  return (
    <Flex justifyItems={'center'} alignItems={'center'}>
      <Box>
        <Text as="span" fontWeight={400} mr={2}>
          {authorNames}
          {shouldShowToggle && !showAll && ','}
        </Text>

        {shouldShowToggle && (
          <ButtonText
            variant="outline"
            onClick={() => setShowAll(prev => !prev)}
          >
            {showAll
              ? 'Show Less'
              : `+${remainingCount} author${remainingCount > 1 ? 's' : ''}`}
          </ButtonText>
        )}
      </Box>
    </Flex>
  );
};

export default AuthorsTitle;
